<template>
	<article class="index">
		<header class="theme">
			<Theme></Theme>
		</header>
		<div class="content">
			<section class="business-growth">
				<div class="wave-point-box">
					<WavesCom />
				</div>
				<div class="business-growth-content">
					<BusinessGrowth></BusinessGrowth>
					<div class="picture-box">
						<div class="Hollow-hexagon-box">
							<img
								src="https://static.bimcc.com/openim/1664344274286542661F58C263BE1220A2807D627EE72.png"
								class="Hollow-hexagon"
							/>
							<img
								src="https://openim-1309784708.cos.ap-shanghai.myqcloud.com/d8ebe777feed46d0f7c331c80ecc9af9.png"
								class="new-logo"
							/>
						</div>
					</div>
				</div>
			</section>
			<section class="stage-box">
				<div class="stage-background-box"></div>
				<div class="stage-content">
					<Stage></Stage>
				</div>
			</section>
			<section class="digital-upgrade-box">
				<DigitalUpgrade></DigitalUpgrade>
			</section>
			<section class="business-system">
				<div class="business-system-content">
					<h1>工程人专属的零代码业务平台</h1>
					<LrLayoutT
						:btnTitle="btnTitle"
						:dataList="dataList"
					></LrLayoutT>
					<RotationChart
						:title="title"
						:subtitleTitle="subtitleTitle"
						:contentList="contentList"
						:list="list"
						:actImage="actImage"
					></RotationChart>
				</div>
			</section>
			<section class="function-list">
				<FunctionalStructure></FunctionalStructure>
			</section>
			<section class="excellent-enterprise">
				<ExcellentEnterprise></ExcellentEnterprise>
			</section>
			<section class="management-tool">
				<ManagementTool></ManagementTool>
			</section>
		</div>
		<footer class="footer"><PublicFooter></PublicFooter></footer>
	</article>
</template>

<script>
import WavesCom from '@/components/wavesCom/index.vue';
import LrLayoutT from '@/components/lrLayoutT/LrLayoutT.vue';
import PublicFooter from '@/components/publicFooter';
import Theme from './components/Theme';
import Stage from './components/Stage';
import DigitalUpgrade from './components/DigitalUpgrade';
import FunctionalStructure from './components/FunctionalStructure';
import RotationChart from '@/components/rotationChart/RotationChart';
import BusinessGrowth from './components/BusinessGrowth';
import ExcellentEnterprise from './components/ExcellentEnterprise';
import ManagementTool from './components/ManagementTool';
export default {
	name: 'homePage',
	components: {
		Theme,
		BusinessGrowth,
		Stage,
		DigitalUpgrade,
		FunctionalStructure,
		LrLayoutT,
		ExcellentEnterprise,
		ManagementTool,
		WavesCom,
		RotationChart,
		PublicFooter
	},
	props: {},
	data() {
		return {
			btnTitle: '免费试用',
			title: '灵活易用的九大引擎，不懂代码也能搭建应用',
			subtitleTitle: '助力企业快速实现数字化转型',
			// 当前轮播背景图
			actImage:
				'https://static.bimcc.com/openim/%E5%9B%BE%E5%85%83%E6%95%B0%E6%8D%AE%E5%BB%BA%E6%A8%A1%281%2949A9DFD0D7D31E15FF7F3FD0789E730D.png',
			dataList: [
				{
					id: 0,
					title: '不给管理找麻烦',
					text: '不为了管理而管理，一切功能都可按需搭建，灵活的框架和丰富的模板把复杂交给系统，把简单留给管理',
					image:
						'https://static.bimcc.com/openim/%E9%A6%96%E9%A1%B5-%E5%86%85%E5%AE%B93-%E4%B8%8D%E7%BB%99%E7%AE%A1%E7%90%86%E6%89%BE%E9%BA%BB%E7%83%A6943B589CAF058F69B11489E8273D715D.png',
					color: 'purple',
					background: 'https://static.bimcc.com/openim/Frame%201032CD19E4004960F410C5C4EF668FDF71EF.png',
					direction: 'right',
					showBtn: true
				},
				{
					id: 1,
					title: '不让用户改习惯',
					text: '不同类型的项目创建不同方式的交互，系统的改变，只为成就用户的永恒',
					image:
						'https://static.bimcc.com/openim/%E9%A6%96%E9%A1%B5-%E5%86%85%E5%AE%B93-%E4%B8%8D%E8%AE%A9%E7%94%A8%E6%88%B7%E6%94%B9%E4%B9%A0%E6%83%AF899AA2E5BC2A563B095F3C64C2A0B05E.png',
					color: 'purple',
					background: 'https://static.bimcc.com/openim/Frame%201019%281%29E8E2D08CC28B348512120017DB613CD8.png',
					direction: 'left',
					showBtn: true
				},
				{
					id: 2,
					title: '不为重复费精力',
					text: '不让用户填入一条重复数据，所有数据“一穿到底”，只为给工程人更多的时间去专注项目本身',
					image:
						'https://static.bimcc.com/openim/%E9%A6%96%E9%A1%B5-%E5%86%85%E5%AE%B93-%E4%B8%8D%E4%B8%BA%E9%87%8D%E5%A4%8D%E8%B4%B9%E7%B2%BE%E5%8A%9B1D74984DE37969C3E5AF0394DFCDD475.png',
					color: 'purple',
					background: 'https://static.bimcc.com/openim/Frame%20103124C2F225B51AE92BF1436DB9D3771B0E.png',
					direction: 'right',
					showBtn: true
				}
			],
			contentList: [
				{
					id: 0,
					showMore: true,
					title: '元数据建模引擎',
					image:
						'https://static.bimcc.com/openim/%E6%95%B0%E4%BB%93%E6%BA%90%E6%95%B0%E6%8D%AE%E5%BB%BA%E6%A8%A1%E5%BC%95%E6%93%8EC309AFF369DC12DDB9B8428D65BE6FAF.png',
					p: 'ER图建模构建业务模型、建立业务模型之间的关系、配置适用于业务模型的统一规则等能力，帮助开发者快速完成模型的构建为后续页面和流程设计提供稳定基础能力，如模型服务、事件行为条件规则等。',
					href: '/products/data-modeling'
				},
				{
					id: 1,
					showMore: true,
					title: '无代码页面渲染引擎',
					image: 'https://static.bimcc.com/openim/%E6%97%A0%E4%BB%A3%E7%A0%8125F25478E4D300DBD6667C6BD7B05DBB.png',
					p: '提供数百种拖拽组件搭建页面，可视化配置按钮事件等能力，帮助开发者快速完成页面的构建；自定义能力满足企业个性化需求，如组件自定义、页面事件自定义、应用主题自定义，一站配置多终端适配l对WEB、H5/APP、大屏、门户、官网等多场景多端覆盖等。',
					href: '/products/no-code'
				},
				{
					id: 2,
					showMore: true,
					title: 'BIMGIS数字孪生引擎',
					image: 'https://static.bimcc.com/openim/1665208305618BE93E601552585D6F4217D4205699C70.png',
					p: '以BIMGIS为载体结合页面渲染引擎灵活搭建数字孪生3D可视化应用，可交互的BIM&GIS组件，自定义渲染逻辑让交互随心所欲；灵活的事件系统，提供最小单元的事件组织能力。',
					href: '/products/digital-twin'
				},
				{
					id: 3,
					showMore: true,
					title: '表单引擎',
					image: 'https://static.bimcc.com/openim/1665214783795A714BCF368911DF12BC8D9A161442B1B.png',
					p: '30+基础控件，数十个工程专业控件以及布局控件，通过简单拖拉的方式即可生成各种场景表单，丰富的字段类型、强大的公式计算规则，自定义的表单样式，跨组织跨应用的数据关联应用，让你的企业管理如虎添翼。',
					href: '/products/form-engine'
				},
				{
					id: 4,
					showMore: true,
					title: '流程引擎',
					image: 'https://static.bimcc.com/openim/16652148453246DCF87DF5E186B1AF4101CC6D276A72A.png',
					p: '强大灵活的流程引擎，灵活便捷地定制流程就如同绘制流程图一样灵活便捷，兼容中国特色的企事业单位审批流，提供拖拉拽流程元素，通过可视化配置参与者、节点操作、节点字段权限等各种属性，帮助管理者快速构建流程。',
					href: '/products/process-engine'
				},
				{
					id: 5,
					showMore: true,
					title: '逻辑蓝图&ETL视图引擎',
					image: 'https://openim-1309784708.cos.ap-shanghai.myqcloud.com/0936849f24003d46fb2e2f6b285a62c0.png',
					p: '蓝图：一系列事件触发器自动化操作过程，可灵活扩展业务互联穿透修改能力；ETL：元数据加工，数据抽取（extract）、转换（transform）、加载（load），跨表组织汇总与分析',
					href: '/products/blueprint'
				},
				{
					id: 6,
					showMore: true,
					title: '数据表格引擎',
					image: 'https://static.bimcc.com/openim/166521488637260D59497617AF7D5BEE410D6B98C979B.png',
					p: '多种打印视图完美实现千人千面的数据打印展示；可视化设计打印模板，一键批量操作，处理数据更敏捷。已有Excel数据表导入，或平台数据导出让你的数据处理轻松高效。',
					href: '/products/data-table'
				},
				{
					id: 7,
					showMore: true,
					title: '360°全景引擎',
					image: 'https://static.bimcc.com/openim/166521486640566A8521B2518BCAA00AC1953178CD695.png',
					p: '工地集成智能硬件传感器，为现场施工工地装上眼睛，3维模型人员定位，环境监测、塔吊升降机监测，AI识别智能报警，基坑高支模监测，视频监控，360°全景实时巡检，全景形象进度对比，延时摄影，无人机监测等构成指挥中心大脑。',
					href: '/products/panorama'
				},

				{
					id: 8,
					showMore: true,
					title: '任务自动化引擎',
					image: 'https://openim-1309784708.cos.ap-shanghai.myqcloud.com/f0f51cd2a0cebd66499d5a42073bb3d3.png',
					p: '可视化任务流程编排建模，多分支串行并行任务执行，条件网关，自定义流转规则',
					href: '/products/automation-engine'
				}
			],
			list: [
				{
					id: 0,
					title: '元数据建模引擎',
					icon: 'https://openim-1309784708.cos.ap-shanghai.myqcloud.com/04ab4d36cd5a5709c7e03f4b3fe52e65.png',
					image:
						'https://static.bimcc.com/openim/%E6%95%B0%E4%BB%93%E6%BA%90%E6%95%B0%E6%8D%AE%E5%BB%BA%E6%A8%A1%E5%BC%95%E6%93%8EC309AFF369DC12DDB9B8428D65BE6FAF.png'
				},
				{
					id: 1,
					title: '无代码页面渲染引擎',
					icon: 'https://openim-1309784708.cos.ap-shanghai.myqcloud.com/9bde5970e4405ca089d73c5742a12fe6.png',
					image: 'https://static.bimcc.com/openim/%E6%97%A0%E4%BB%A3%E7%A0%8125F25478E4D300DBD6667C6BD7B05DBB.png'
				},
				{
					id: 2,
					title: 'BIMGIS数字孪生引擎',
					icon: 'https://openim-1309784708.cos.ap-shanghai.myqcloud.com/8ff858b6feeab7d021ea5ab5cd28a21f.png',
					image: 'https://static.bimcc.com/openim/1665208305618BE93E601552585D6F4217D4205699C70.png'
				},
				{
					id: 3,
					title: '表单引擎',
					icon: 'https://static.bimcc.com/openim/Group%2034A2CE1F11D979D4E8628E51EBF09AA9E1.png',
					image:
						'https://static.bimcc.com/openim/%E8%87%AA%E5%AE%9A%E4%B9%89%E8%A1%A8%E5%8D%95147E7414A03BE257AC959ED5981E01A8.png'
				},
				{
					id: 4,
					title: '流程引擎',
					icon: 'https://static.bimcc.com/openim/Group%203564472990F3D88C9A04E9D0E6382C22B8.png',
					image:
						'https://static.bimcc.com/openim/%E5%B7%A5%E4%BD%9C%E5%AE%A1%E6%89%B91F737C0F0FB5F7BB5CDF3878301B8138.png'
				},
				{
					id: 5,
					title: '逻辑蓝图&ETL视图引擎',
					icon: 'https://openim-1309784708.cos.ap-shanghai.myqcloud.com/c3aac7e14174031be935d6446eb188b9.png',
					image:
						'https://static.bimcc.com/openim/%E6%95%B0%E6%8D%AE%E8%A1%A8%E6%A0%BC4D81918036769447C90C42F55A248DA2.png'
				},
				{
					id: 6,
					title: '数据表格引擎',
					icon: 'https://openim-1309784708.cos.ap-shanghai.myqcloud.com/dc15f96bbf28c1083ae027b854422bda.png',
					image:
						'https://static.bimcc.com/openim/%E6%95%B0%E6%8D%AE%E8%A1%A8%E6%A0%BC4D81918036769447C90C42F55A248DA2.png'
				},
				{
					id: 7,
					title: '360°全景引擎',
					icon: 'https://openim-1309784708.cos.ap-shanghai.myqcloud.com/7cb62c36bec7636d66d78533d56c08be.png',
					image:
						'https://static.bimcc.com/openim/%E6%99%BA%E6%85%A7%E5%B7%A5%E5%9C%B0F826330ACB625958CAE637557657DA36.png'
				},
				{
					id: 8,
					title: '任务自动化引擎',
					icon: 'https://openim-1309784708.cos.ap-shanghai.myqcloud.com/da82a9e98dcd854b1f08a9804b04ff6a.png',
					image:
						'https://static.bimcc.com/openim/%E6%95%B0%E6%8D%AE%E8%A1%A8%E6%A0%BC4D81918036769447C90C42F55A248DA2.png'
				}
			]
		};
	},
	methods: {}
};
</script>

<style lang="less" scoped>
:deep(.el-button) {
	border: none;
}
.index {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	width: 100%;
	.theme {
		display: flex;
		justify-content: center;
		position: relative;
		width: 100%;
		background-image: url(https://static.bimcc.com/openim/16639259806581BEFD48FAD448B41101EA20A4DCB83D2.png);
		background-size: 100% 100%;
		background-repeat: no-repeat;
	}
	.content {
		width: 100%;
		.business-growth {
			display: flex;
			justify-content: center;
			position: relative;
			width: 100%;
			padding-bottom: 162px;
			box-sizing: border-box;
			background: #fff;
			.wave-point-box {
				position: absolute;
				bottom: 0;
				left: 0;
				right: 0;
				width: 100%;
				height: 400px;
			}
			.business-growth-content {
				display: flex;
				justify-content: center;
				align-items: center;
				position: relative;
				width: 1200px;
				height: 920px;
				.picture-box {
					position: absolute;
					width: 26%;
					text-align: center;
					.Hollow-hexagon-box {
						position: relative;
						width: 100%;
						.Hollow-hexagon {
							width: 100%;
						}
						.new-logo {
							position: absolute;
							top: 28%;
							left: 31%;
							width: 40%;
						}
					}
				}
			}
		}
		.digital-upgrade-box {
			display: flex;
			justify-content: center;
			position: relative;
			width: 100%;
			background: #fff;
		}
		.stage-box {
			display: flex;
			justify-content: center;
			position: relative;
			width: 100%;
			height: 856px;
			background: #f9fbff;
			.stage-background-box {
				position: absolute;
				bottom: 106px;
				width: 1000px;
				height: 660px;
				background-image: url(https://static.bimcc.com/openim/166425713796921B459AC0E5194B540D9D58BE0F1D6AA.png);
				background-size: 100% 100%;
				background-repeat: no-repeat;
			}
			.stage-content {
				display: flex;
				justify-content: center;
				align-items: center;
				width: 100%;
				height: 660px;
				padding-top: 100px;
				box-sizing: border-box;
			}
		}
		.business-system {
			position: relative;
			width: 100%;
			background: #fff;
			text-align: center;
			.business-system-content {
				display: inline-block;
				width: 1200px;
				h1 {
					padding: 59px 0 60px 0;
					box-sizing: border-box;
					color: #131314;
					font-family: 'Source Han Sans CN';
					font-style: normal;
					font-weight: 700;
					font-size: 42px;
					line-height: 63px;
				}
			}
		}
		.function-list {
			display: flex;
			justify-content: center;
			position: relative;
			width: 100%;
			padding-bottom: 93px;
			box-sizing: border-box;
			background: #fff;
		}
		.excellent-enterprise {
			display: flex;
			justify-content: center;
			position: relative;
			width: 100%;
			background: rgba(222, 233, 255, 0.3);
		}
		.management-tool {
			display: flex;
			justify-content: center;
			position: relative;
			width: 100%;
			background: #fff;
			.management-tool-content {
				display: flex;
				justify-content: center;
				align-items: center;
				width: 1200px;
			}
		}
	}
	.footer {
		width: 100%;
		background: #eaf1ff;
	}
}
</style>
